import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { stockApi } from "@/lib/stock.api";
import { queryKeys } from "@/lib/query-keys";

export function useDeleteStockArticleMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => stockApi.remove(id).then((r) => r.data),
    onSuccess: () => {
      toast.success("Article supprimé.");
      queryClient.invalidateQueries({ queryKey: queryKeys.stock() });
    },
  });
}
